// 📁 components/PublicProfile/MutualFriendsList.jsx
// Displays a paginated list of mutual friends.
import React from 'react';
import ProfileImage from '../ProfileImage';

const MutualFriendsList = ({ mutualFriends, page, totalPages, onPageChange }) => {
    if (!mutualFriends.length) return null;

    return (
        <div className="mutual-friends">
            <h4>Mutual Friends ({mutualFriends.length})</h4>
            <ul>
                {mutualFriends.map(friend => (
                    <li key={friend._id} className="mutual-friend-item">
                        <ProfileImage
                            src={friend.profilePicture}
                            className="mutual-friend-avatar"
                            alt={`${friend.nickname || friend.username}'s avatar`}
                        />
                        <span>{friend.nickname || friend.username}</span>
                    </li>
                ))}
            </ul>
            <div className="pagination">
                <button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>← Prev</button>
                <span>Page {page} of {totalPages}</span>
                <button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>Next →</button>
            </div>
        </div>
    );
};

export default MutualFriendsList;
